import { Button, Popconfirm, Typography } from 'antd';

const { Text } = Typography;

interface IProps {
  okText?: string;
  cancelText?: string;
  buttonText?: string;
  buttonType?: 'primary' | 'default' | 'dashed' | 'text' | 'link';
  loading?: boolean;
  onConfirm: () => void;
}
export const UnsavedChangesButton: React.FC<IProps> = ({
  buttonText = 'Save',
  buttonType = 'default',
  okText = 'Yes',
  cancelText = 'No',
  loading,
  onConfirm,
}) => {
  return (
    <Popconfirm
      title="You might have unsaved changes?"
      description={
        <Text>
          To save your changes and proceed, click <strong> Save </strong>
          Click <strong>Cancel</strong> to go back without saving.
        </Text>
      }
      okText={okText}
      cancelText={cancelText}
      onConfirm={onConfirm}
    >
      <Button type={buttonType} disabled={loading} loading={loading}>
        {buttonText}
      </Button>
    </Popconfirm>
  );
};
